import { createContext, useContext } from 'react';

import type { DndDragHandleProps } from '~/components/core/DndOrderedList/DndOrderedList.types';

// The same handle `renderItem` receives, carried by context for consumers that cannot take it as a
// prop: an item whose children are materialised by someone else's render callback (FsIndexPanel's
// `renderChild`, which supplies each section's scroll anchor and SafeComponent boundary) has no
// place to thread it through. `DndOrderedListItem` provides it around every item, so a consumer at
// any depth can pick it up, and one taking the handle as a prop simply never reads it.
const DndDragHandleContext = createContext<DndDragHandleProps | undefined>(undefined);

export const DndDragHandleProvider = DndDragHandleContext.Provider;

export const useDndDragHandle = (): DndDragHandleProps | undefined => useContext(DndDragHandleContext);
